<template>
  <v-card>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs4 lg2 class="center_middle d-flex">
          <v-avatar
            :size="70"
            >
            <profile-image class="img-cst" :src="$store.getters.getUserProfileImage(item.sppdEmployee.employee.job.profileImage)" />
          </v-avatar>
        </v-flex>
        <v-flex xs8 lg10>
        <v-card-text>
          <h3>{{item.sppdEmployee.employee.name}} - {{item.sppdEmployee.employee.job.jobProfileName}}
            ({{item.sppdEmployee.employee.nik}}) | {{item.sppdEmployee.employee.job.divisionDept}}</h3>
            <v-chip class="mx-0" small label :color="getdocstateColor(item.documentState)" text-color="white">
              <strong>{{item.documentState}}</strong>
            </v-chip>
            <br class="hidden-sm-and-up">
            <v-chip class="mx-0" small label :color="item.sppdState === 'REALIZATION' ? 'success' : 'yellow darken-2'" text-color="white">
            {{item.sppdState}}
            </v-chip>
            {{item.batchNo}} |
            {{item.fromDate | moment('DD MMM YYYY')}} - {{item.toDate | moment('DD MMM YYYY')}}<br />
          <p>{{item.totalRealization | numformat('Rp.', 0)}} | R.Date:
            {{item.realizationDate | moment('DD MMM YYYY')}}</p>
        </v-card-text>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import ProfileImage from '@/components/ProfileImage'

export default {
  name: 'RealizationCard',
  components: {
    ProfileImage
  },
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  methods: {
    getdocstateColor (val) {
      return val === 'DRAFTED' ? 'grey darken-4' : val === 'SUBMITTED' ? 'success' : val === 'APPROVED' ? 'primary' : val === 'REJECTED' ? 'error' : val === 'REVISION' ? 'yellow accent-4' : 'orange'
    }
  },
  data () {
    return {
      item: this.value
    }
  }
}
</script>
<style scoped>
@media only screen and (max-width: 599px) {
  .mx-auto{
    font-size: 12px;
  }
}
.center_middle{
  align-items: center !important;
}
.img-cst{
  border: 1px solid rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/bt-realization/RealizationCard.vue